import { useEffect, useRef, useLayoutEffect } from 'react';
import RingBuffer from './ring-buffer';

const Log = () => {
  console.log('[Log] Factory');
  if (process.env.VITE_APP_CONSOLE !== '1') {
    console.log('[Log] Disabled');
    window['console']['log'] = function () {};
  }
  const messages = new RingBuffer(100);
  return {
    messages,
    log(...args: any[]) {
      const preservedConsoleLog = console.log;
      preservedConsoleLog.apply(console, args);
      if (process.env.VITE_APP_CONSOLE_MESSAGES === '1') {
        messages.push(args);
      }
    },
  };
};

export function useWhyDidYouUpdate(name, props) {
  const log = Log();
  // Get a mutable ref object where we can store props ...
  // ... for comparison next time this hook runs.
  const previousProps = useRef<Object>();
  const count = useRef(0);
  // First Time
  useLayoutEffect(() => {
    const allKeys = Object.keys({ ...props });
    const changesObj = {};
    allKeys.forEach((key) => (changesObj[key] = props[key]));
    // If changesObj not empty then output to console
    if (Object.keys(changesObj).length) {
      log.log(`>${count.current}`, name, changesObj);
    }
    previousProps.current = props;
    count.current = count.current + 1;
    return () => {
      // Unmount
      log.log(`<${count.current}`, name, '-Unmounted-');
    };
    // eslint-disable-off-next-line-off react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (previousProps.current) {
      // Get all keys from previous and current props
      const allKeys = Object.keys({ ...previousProps.current, ...props });
      // Use this object to keep track of changed props
      const changesObj = {};
      // Iterate through keys
      allKeys.forEach((key) => {
        // If previous is different from current
        if (previousProps.current[key] !== props[key]) {
          // Add to changesObj
          changesObj[key] = {
            from: previousProps.current[key],
            to: props[key],
          };
        }
      });

      // If changesObj not empty then output to console
      if (Object.keys(changesObj).length) {
        log.log(`#${count.current}`, name, changesObj);
      }
    }

    // Finally update previousProps with current props for next hook call
    previousProps.current = props;
    count.current = count.current + 1;
  });
}
